import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';
import {
	LOCALIZATION,
	LOCALIZATION_FAILURE,
	LOCALIZATION_REQUEST,
	LOCALIZATION_SUCCESS,
} from 'new-constants/api.constants';
import {getLocalization} from 'new-actions/api.actions.ts';

function isLocalizationNotFetched(customer, localization) {
	if (!localization.translations) {
		return true;
	}

	return false;
}

function isLocalizationOutdated(customer, localization) {
	if (!(customer && customer.locale && customer.translationVersion)) {
		return false;
	}

	if (customer.locale !== localization.locale || customer.translationVersion !== localization.version) {
		return true;
	}

	return false;
}

function* getLocalizationIfNecessary() {
	const state = yield select();

	const {
		fetchProgress,
		customer: {currentCustomer},
		localization,
		connectivity,
	} = state;

	if (fetchProgress[LOCALIZATION]) return;

	if (
		(isLocalizationNotFetched(currentCustomer, localization) ||
			isLocalizationOutdated(currentCustomer, localization)) &&
		connectivity.isOnline !== false
	) {
		yield putResolve(getLocalization(currentCustomer?.locale, currentCustomer?.translationVersion));
	}
}

export const localizationUpdaterSaga = function* localizationUpdaterSaga() {
	yield throttle(
		2500,
		[action => ![LOCALIZATION_REQUEST, LOCALIZATION_SUCCESS, LOCALIZATION_FAILURE].includes(action.type)],
		getLocalizationIfNecessary
	);
};
